<template>
    <div class="row mt-5">
        <div class="col-md-4 spark-settings-tabs">
            <aside v-if="selectedReport.id === 'foundation-customers'">
                <h3 class="nav-heading">
                    Costumers
                </h3>
                <div class="rounded w-full px-2 text-grey-darker">
                    <div class="flex text-center mb-3">
                        <button class="btn-link mr-3" for="all" @click="selectAll">Select all </button>
                        <button class="btn-link" for="none" @click="selectedCustomers = [], selectedJobs = []">Clear all  </button>
                    </div>
                    <div  class="text-justify overflow-y-auto" style="max-height: 60vh">
                        <div v-for="customer of customers" :key="customer.id">
                            <input type="checkbox" name="master-customers-list" :value="customer.id" v-model="selectedCustomers">
                            <label :for="customer.name">{{customer.name}}</label>
                        </div>
                    </div>
                </div>
            </aside>
        </div>
        <div class="col-md-8">
            <div class="pull-right">
                <button
                    class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-3 rounded-full text-followup-nav"
                    @click="generateReport" type="button">
                    Get Report
                </button>
                <button v-if="team.has_scheduled_reports_access && userRole !== 'view_only'"
                        class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white ml-3 px-3 rounded-full text-followup-nav"
                        @click.prevent="openScheduler" type="button">
                    Schedule
                </button>
            </div>
            <div id="master-customer-reports" >
                <div class="rounded w-full px-2 text-grey-darker text-justify">
                     <h3 class="nav-heading ">
                        Reports / Exports
                    </h3>
                    <div v-for="report of reports" :key="report.id">
                        <input type="radio" name="to_generate" :value="getValue(report)" v-model="selectedReport">
                        <label :for="report.name">{{report.name}}</label>
                    </div>
                </div>
            </div>
        </div>
        <div id="scheduleFoundationReport" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content schedule-modal">
                    <div class="modal-body text-dark">
                        <h4 class="text-center mb-2">Automated Report Scheduling
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </h4>
                        <div class="form-group mb-2">
                            <label class="text-grey-darkest text-sm" for="email_subject">Email Subject <span class="text-danger">*</span></label>
                            <input type="text" class="p-1 bg-white border-1 focus:outline-none text-grey-darkest text-sm form-control" v-model="scheduleReportForm.subject" name="email_subject" id="email_subject" placeholder="Enter email subject"/>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.subject">{{ scheduleReportErrors.subject }}</span>
                        </div>

                        <div class="form-group mb-2">
                            <label class="text-grey-darkest text-sm">Recipients <span class="text-danger">*</span></label>
                            <multiselect v-model="scheduleReportForm.recipients"
                                         id="recipientEmailSelected"
                                         tag-placeholder="Press enter to add"
                                         placeholder="Add an email"
                                         :options="options"
                                         :multiple="true"
                                         track-by="email"
                                         label="email"
                                         :taggable="true"
                                         :close-on-select="false"
                                         @tag="addRecipient">
                                <template v-slot:noOptions>
                                    <span style="display:none"> List is empty. </span>
                                </template>
                            </multiselect>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.recipients">{{ scheduleReportErrors.recipients }}</span>
                        </div>

                        <div class="form-group mb-2">
                            <label class="text-grey-darkest text-sm"
                                   for="delivery_frequency">Delivery Frequency <span class="text-danger">*</span></label>
                            <select name="delivery_frequency" id="delivery_frequency" v-model="scheduleReportForm.delivery_frequency"
                                    class="p-1 bg-white border-1 focus:outline-none text-grey-darkest text-sm form-control" required @change="frequencyChanged($event)" >
                                <option selected disabled>Select frequency</option>
                                <option value="Daily">Daily</option>
                                <option value="Weekly">Weekly</option>
                                <option value="Monthly">Monthly</option>
                            </select>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.delivery_frequency">{{ scheduleReportErrors.delivery_frequency }}</span>
                        </div>

                        <div class="form-group mb-2">
                            <label class="text-grey-darkest text-sm mb-0"
                                   for="scheduled_time">Scheduled Time <span class="text-danger">*</span></label>
                            <p><small>Data is captured up to 2 hours before the email is sent. This is to make sure this email is delivered as on-time as possible.</small></p>
                            <datetime type="time" name="scheduled_time" format="hh:mm a" use12-hour :minute-step="15" required v-model="scheduleReportForm.scheduled_time" id="scheduled_time" class="p-1 bg-white border-1 focus:outline-none text-grey-darkest text-sm form-control"></datetime>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.scheduled_time">{{ scheduleReportErrors.scheduled_time }}</span>
                        </div>

                        <div class="form-group mb-2">
                            <label class="text-grey-darkest text-sm"
                                   for="scheduled_day">Delivery Day <span class="text-danger">*</span></label>
                            <select name="scheduled_day" id="scheduled_day" v-model="scheduleReportForm.scheduled_day"
                                    class="p-1 border-1 focus:outline-none text-grey-darkest text-sm form-control" :disabled="scheduleReportForm.scheduled_day_disabled">
                                <option selected disabled>Select date</option>
                                <option value="monday">Monday</option>
                                <option value="tuesday">Tuesday</option>
                                <option value="wednesday">Wednesday</option>
                                <option value="thursday">Thursday</option>
                                <option value="friday">Friday</option>
                                <option value="saturday">Saturday</option>
                                <option value="sunday">Sunday</option>
                            </select>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.scheduled_day">{{ scheduleReportErrors.scheduled_day }}</span>
                        </div>

                        <div class="text-center mt-4">
                            <button class="btn btn-primary rounded-full" @click="scheduleReport">
                                Schedule Report Email
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Mixin from './mixin';
import Form from "../../utils/form";
import Multiselect from "vue-multiselect";

export default {
    mixins: [Mixin],

    name: 'foundation-report',

    props: ['filter-uri', 'userRole', 'team'],
    components: {Multiselect},
    data() {
        return {
            customers: [],
            selectedCustomers: [],
            selectedJobs: [],
            selectedReport: [],
            reports: [
                { id: 'foundation-customers', name: 'Customers', excel: true },
                { id: 'foundation-jobs', name: 'Projects', excel:true },
            ],
            scheduleReportForm : new Form({
                subject: '',
                recipients:[],
                delivery_frequency: '',
                scheduled_time: '',
                scheduled_day: '',
                report_id: '',
                report_name: '',
                report_format: '',
                'start-date': '',
                'end-date': '',
                user: '',
                office: '',
                'contract-type': '',
                'fixed-date-range-identifier': '',
                customer_ids: '',
                scheduled_day_disabled : false,
            }),
            scheduleReportHasError: false,
            scheduleReportErrors: {
                subject:'',
                recipients:'',
                delivery_frequency:'',
                scheduled_time:'',
                scheduled_day:'',
                report_format:'',
            },
            options                      : [],
        }
    },
    created(){
        this.getCustomers();
    },

    watch:{
        selectedReport(val){
            this.$emit('change-report', val.id);
        },
        scheduleReportForm: {
            immediate: false,
            handler: function (scheduleValue, oldVal) {
                if(scheduleValue.subject!==""){
                    this.scheduleReportErrors.subject='';
                    this.scheduleReportHasError = false
                }
                if(scheduleValue.recipients.length > 0){
                    this.scheduleReportErrors.recipients='';
                    this.scheduleReportHasError = false
                }
                if(scheduleValue.delivery_frequency!==""){
                    this.scheduleReportErrors.delivery_frequency='';
                    this.scheduleReportHasError = false
                }
                if(scheduleValue.scheduled_time!==""){
                    this.scheduleReportErrors.scheduled_time='';
                    this.scheduleReportHasError = false
                }
                if(scheduleValue.scheduled_day!==""){
                    this.scheduleReportErrors.scheduled_day='';
                    this.scheduleReportHasError = false
                }
                if(scheduleValue.report_format!==""){
                    this.scheduleReportErrors.report_format='';
                    this.scheduleReportHasError = false
                }
            },
            deep: true
        }
    },

    methods: {
        frequencyChanged(event) {
            console.log(event.target.value)
            if(event.target.value === "Daily") {
                this.scheduleReportForm.scheduled_day_disabled = true
            }else {
                this.scheduleReportForm.scheduled_day_disabled = false
            }
        },
        getValue(report){
            return {
                id: report.id,
                name: report.name,
                excel: report.excel,
                pdf: report.pdf ?? null
            }
        },

        getCustomers(){
            axios.get(route('api.company.list-for-report')).then((response) => {
                this.customers = response.data;
            });
        },

        generateReport() {
            if(this.selectedReport && this.selectedCustomers || this.selectedJobs)  {
                let path = '';

                let uri = this.filterUri.substr(0, this.filterUri.length);
                uri += '&name=' + this.selectedReport.name;

                path += "/reports-charts/" + this.selectedReport.id + uri + '&excel=true';

                if (this.checkValidations(path)){
                    return;
                }
                let form = new Form({
                    type : JSON.stringify(this.selectedCustomers),
                })

                let self = this;
                axios.post(path, form).then(response => {
                    path += '&is_foundation_tab=true'
                    this.createPop(path, this.selectedReport);
                }).catch(error => {
                    if(error){
                        self.getToast().fire({
                            title: "Message",
                            text: "This is not a bug! You just don't have access to this record. Ask your administrator for more details.",
                            confirmButtonColor: 'red',
                            dangerMode: true,
                        });
                    }
                });
            }
        },

        selectAll(){
            let self = this;

            if (this.selectedReport.id === 'foundation-customers') {
                self.selectedCustomers = [];
                this.customers.forEach(customer => self.selectedCustomers.push(customer.id));
            } else if (this.selectedReport.id === 'foundation-jobs') {
                self.selectedJobs = [];
                this.jobs.forEach(customer => self.selectedJobs.push(customer.id));
            }
        },
        openScheduler() {
            if(this.selectedReport)  {
                this.scheduleReportForm.reset();
                this.scheduleReportForm.report_format = 'excel'
                this.scheduleReportForm.scheduled_day_disabled = false
                this.scheduleReportErrors = {
                    subject:'',
                    recipients:'',
                    delivery_frequency:'',
                    scheduled_time:'',
                    scheduled_day:'',
                    report_format:'',
                    selected_leads:'',
                }
                $("#scheduleFoundationReport").modal("show");
            }
        },
        addRecipient(newEmail) {
            let mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
            if (newEmail.match(mailFormat)) {
                const tag = {
                    email: newEmail,
                };
                this.scheduleReportForm.recipients.push(tag);
            } else {
                this.fireErrorToast("You have entered an invalid email address!");
            }
        },
        toggleSchedule() {
            this.showSchedule = !this.showSchedule
        },
        scheduleReport() {
            this.scheduleReportHasError = false;
            this.scheduleReportForm.report_name = this.selectedReport.name
            this.scheduleReportForm.report_id = this.selectedReport.id
            this.validateField('subject', 'Subject');
            this.validateField('recipients', 'Recipients');
            this.validateField('delivery_frequency', 'Delivery Frequency');
            this.validateField('scheduled_time', 'Scheduled Time');
            if(this.scheduleReportForm.delivery_frequency != "Daily"){
                this.validateField('scheduled_day', 'Delivery Day');
            }

            if(this.selectedReport.pdf && this.selectedReport.excel) {
                this.validateField('report_format', 'Format');
            }
            if(this.scheduleReportHasError) {
                return false
            }

            this.scheduleReportForm.customer_ids = JSON.stringify(this.selectedCustomers)
            const params = this.filterUri.replace('?','').split('&');
            params.map((param) => {
                const filter = param.split('=')
                this.scheduleReportForm[filter[0]] = filter[1];
            })

            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            axios.post(route('api.schedule-report.store'), this.scheduleReportForm).then(response => {
                if (response.data.status) {
                    Toast.fire({
                        type: "success",
                        title: response.data.message
                    });
                    this.scheduleReportForm.reset();
                    $("#scheduleFoundationReport").modal("hide");
                } else {
                    Toast.fire({
                        type: "error",
                        title: response.data.message
                    });
                }
            }).catch((error) => {
                console.log('error', error);
            })
        },
        validateField(fieldName, fieldLabel) {
            if(fieldName === 'recipients') {
                if(this.scheduleReportForm[fieldName].length === 0) {
                    this.scheduleReportErrors[fieldName] = fieldLabel+' is required'
                    this.scheduleReportHasError = true
                }
            }else{
                if(!this.scheduleReportForm[fieldName].trim()) {
                    this.scheduleReportErrors[fieldName] = fieldLabel+' is required'
                    this.scheduleReportHasError = true
                }
            }

        }
    }
  };
</script>
